// Liberação da API Oficial do WhatsApp (tela de Conexões e Templates Oficiais).
// Enquanto o recurso não é liberado para a base toda, as telas ficam com o
// aviso "Em breve" — exceto para os contratos listados aqui.
//
// O `id_empresa` do hook de auth é o NrContrato da empresa (gestores.IdEmpresa
// referencia empresas.NrContrato), então a comparação é direta.
//
// ─────────────────────────────────────────────────────────────────────────────
// COMO LIBERAR PARA TODOS / REVERTER O BLOQUEIO
// ─────────────────────────────────────────────────────────────────────────────
// Liberar mais uma loja: basta adicionar o número do contrato no array abaixo.
//
// Remover o bloqueio de vez: fazer `temAcessoApiOficial` sempre retornar `true`
// ou desfazer os pontos abaixo — são TODOS os lugares tocados por este gate:
//
// 1. src/components/Menu/index.jsx
//    - import de `temAcessoApiOficial` e do styled `SoonBadge`;
//    - const `apiOficialLiberada` (logo após o `useState` do changePass);
//    - menu "Robô" → item "Conexões" virou ternário: liberado = item normal,
//      bloqueado = item `disabled` com o selo "Em breve".
//
// 2. src/components/Menu/styles.js
//    - styled-component `SoonBadge` (selo amarelo "Em breve" do menu lateral).
//
// 3. src/pages/Chatbot/Conexoes/index.jsx
//    - imports de `EmBreve` e `temAcessoApiOficial`;
//    - const `apiOficialLiberada` (ao lado do `connected`);
//    - early return dentro de `load()` (evita chamar a API quando bloqueado);
//    - early return no render com <EmBreve /> antes do `if (loading)`.
//      (bloqueia também o acesso pela URL direta /chatbot/conexoes)
//
// 4. src/pages/Chatbot/TemplatesDeMensagens/index.jsx
//    - imports de `EmBreve` e `temAcessoApiOficial`;
//    - const `apiOficialLiberada`;
//    - tab inicial: `useState(apiOficialLiberada ? 'oficiais' : 'sistema')`;
//    - early return dentro de `loadConnection()`;
//    - botões "Mostrar/Ocultar prévia" e "Configurações" só quando liberado;
//    - selo `styles.soonBadge` na tab "Templates Oficiais";
//    - render do corpo: tab "oficiais" mostra <EmBreve /> no lugar de
//      <OfficialTemplates /> quando bloqueado (tab "sistema" nunca é afetada).
//
// 5. src/pages/Chatbot/TemplatesDeMensagens/styles.js
//    - `soonBadge` (selo "Em breve" da tab).
//
// 6. src/components/EmBreve/index.jsx  (arquivo novo)
//    - componente do placeholder "Em breve"; só é usado por este gate, pode ser
//      apagado junto.
//
// 7. este arquivo (src/config/apiOficialWhatsapp.js — arquivo novo).
// ─────────────────────────────────────────────────────────────────────────────
export const CONTRATOS_COM_API_OFICIAL = [2166];

export function temAcessoApiOficial(contrato) {
  return CONTRATOS_COM_API_OFICIAL.includes(Number(contrato));
}
